import { MAP_TYPES } from '@deck.gl/carto';

const POPULATION_SOURCE_ID = 'populationSource';

const source = {
  id: POPULATION_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Broward_County_Block_Groups_Tree_Equity_Health_Demographics`,
};

export default source;
